<script setup>
import { useDeviceStore } from '../../../store/deviceStore';
import { useOrderStore } from '../../../store/orderStore';

import DeviceSelect from './purchase-rent-plan/DeviceSelect.vue';
import QuantitySelect from './purchase-rent-plan/QuantitySelect.vue';


const deviceStore = useDeviceStore();

function handleDeviceType(value) {
    deviceStore.setSelectedDevice(value);
}
</script>

<template>
    <div>
        <h1 class="text-2xl mb-8">Device configuration</h1>
        <div class="bg-white border-2 border-sky-400 rounded-lg px-4 py-6 mb-8">
            <template v-if="deviceStore.canShowDevicesType">
                <div class="border-b-2 border-sky-400 pb-6 mb-6">
                    <h2 class="mb-4">{{ $t("purchase-rent-page.plans.deviceType") }}</h2>

                    <DeviceSelect
                        v-model="deviceStore.selectedDevice.id"
                        @selected="handleDeviceType($event)"
                    />
                </div>

            </template>

            <h2 class="mb-4">{{ $t("purchase-rent-page.plans.deviceQuantity") }}</h2>
            <div class="w-1/2">
                <QuantitySelect 
                    v-model="deviceStore.device_quantity"
                    :placeholder="$t('purchase-rent-page.plans.numberOfDevices')"
                />
            </div>
        </div>
    </div>
</template>